import {
  Cascader,
  DatePicker,
  Button,
  Select,
  Table,
  Modal,
  Input,
  message,
  Form,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import "./index.styl";
import { freezeMember, test } from "../../../api/member";
import {
  getSmartBeanList,
  getSmartBeanDetailList,
  exportSmartBeansExelFile,
} from "../../../api/smartBeans";
import { getTermsData } from "../../../utils/smartBeans";
import { getChildModuleList } from "../../../api/common";
import {
  getStudentInfoList,
  updateStudentInfo,
} from "../../../api/studentInfo";
import { sortByChinese } from "../../../utils/smartBeans";
const { RangePicker } = DatePicker;

export default function StudentInfoSearch() {
  // 本期暂时不做
  const searchContent = useRef("");
  const learnStatus = useRef("");
  const smartBeans = useRef(0);
  const [searchTime, setSearchTime] = useState("");

  // 智慧豆列表
  const pageNo = useRef(1);
  const startSearchBeans = useRef(0);
  const endSearchBeans = useRef(0);
  const [userNum, setUserNum] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [smartBeanList, setSmartBeanList] = useState([]);
  const [editForm] = Form.useForm();
  const [editRecord, setEditRecord] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  // 智慧豆详情列表
  const detailPageNo = useRef(1);
  const [smartBeanDetailList, setSmartBeanDetailList] = useState([]);

  //
  const [searchType, setSearchType] = useState(1);
  const onSearchTypeChanged = useCallback((id) => {
    setSearchType(id);
  }, []);

  const [countrysideData, setCountrysideData] = useState([]);
  const [defaultCountrysideKey, setDefaultCountrysideKey] = useState("");

  useEffect(() => {
    async function getData() {
      onSearchBtnClicked();
    }

    getData();
  }, []);

  useEffect(() => {
    async function fetchCountryList() {
      const newCountrysideData = [{ id: "0", name: "全部" }];
      const res = await getChildModuleList({ main_depart_id: 11 }); //自然村数据
      if (res.code == 0 && res.data?.length > 0) {
        const data = sortByChinese(res.data);
        newCountrysideData.push(...data);

        setCountrysideData(newCountrysideData);
        setDefaultCountrysideKey(newCountrysideData[0].id);
      }
      console.log(res);
    }
    fetchCountryList();
  }, []);

  const getGenderText = useCallback((gender) => {
    return gender == -1 ? "-" : gender == 0 ? "女" : "男";
  }, []);

  const onEditStudentInfoClicked = useCallback(
    (record) => {
      setEditRecord(record);
      editForm.setFieldsValue({
        nick_name: record?.nick_name,
        gender:
          record?.gender === 0 || record?.gender === 1
            ? record.gender
            : undefined,
        phone_no: record?.phone_no,
      });
      setShowEditModal(true);
    },
    [editForm]
  );

  const columns = [
    {
      title: "昵称",
      dataIndex: "nick_name",
      key: "nick_name",
    },
    {
      title: "学号",
      dataIndex: "user_no",
      key: "user_no",
    },

    {
      title: "性别",
      dataIndex: "gender",
      key: "gender",
      render: (_, recoder) => {
        console.log("recoder++++:", recoder);
        return (
          <span onClick={() => onSmartBeansClicked(recoder)} type="link">
            {getGenderText(recoder?.gender)}
          </span>
        );
      },
    },
    {
      title: "所属村落",
      dataIndex: "natural_village",
      key: "natural_village",
      render: (_, recoder) => {
        return <span>{recoder?.natural_village ?? "-"}</span>;
      },
    },
    {
      title: "手机号",
      dataIndex: "phone_no",
      key: "phone_no",
    },
    {
      title: "操作",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          onClick={(event) => {
            event.stopPropagation();
            onEditStudentInfoClicked(record);
          }}
        >
          编辑
        </Button>
      ),
    },
  ];

  const [beansListTotalNum, setBeansListTotalNum] = useState(0);
  const [beansListCurPage, setBeansListCurPage] = useState(1);

  const [periedKey, setPeriedKey] = useState(null);
  const [periedData, setPeriedData] = useState(getTermsData(true));

  // 主列表分页属性
  const paginationProps = {
    // showSizeChanger: true,
    // showQuickJumper: true,
    showTotal: () => `共${beansListTotalNum}条`,
    // pageSize: 10,
    current: beansListCurPage,
    total: beansListTotalNum,
    // onShowSizeChange: (current, pageSize) =>
    //   this.changePageSize(pageSize, current),
    onChange: (current) => onChangeBeansListpage(current),
  };

  const searchBeansList = useCallback(async () => {
    let params = { page_size: 10, page_no: pageNo.current };

    if (userNum > "") {
      if (searchType == 1) {
        params.user_no = userNum;
      } else if (searchType == 2) {
        params.phone_no = userNum;
      } else if (searchType == 3) {
        params.nick_name = userNum;
      }
    }

    if (defaultCountrysideKey != 0 && defaultCountrysideKey) {
      params.natural_village = defaultCountrysideKey;
    }

    if (periedKey > "") {
      params.natural_village_batch_order = periedKey;
    }

    // if (periedKey) {
    //   params.
    // }

    const res = await getStudentInfoList(params);
    if (res.code == 0 && res.data && res.data.list?.length > 0) {
      setSmartBeanList(res.data.list);
      setBeansListTotalNum(res.data.count || 0);
    } else {
      setSmartBeanList([]);
      setBeansListTotalNum(0);
    }
  }, [userNum, searchType, periedKey, defaultCountrysideKey]);

  const onChangeBeansListpage = useCallback(
    (current) => {
      setBeansListCurPage(current);
      pageNo.current = current;
      searchBeansList();
      // eslint-disable-next-line no-use-before-define
    },
    [searchBeansList]
  );

  const smartBeansDetail = [
    {
      title: "录入时间",
      dataIndex: "job_start_time",
      key: "job_start_time",
    },
    {
      title: "板块",
      dataIndex: "main_department",
      key: "main_department",
    },
    {
      title: "子板块",
      dataIndex: "second_department",
      key: "second_department",
    },
    // {
    //   title: "人物角色/内容",
    //   dataIndex: "role",
    //   key: "role",
    // },
    {
      title: "智慧豆",
      dataIndex: "bean_amount",
      key: "bean_amount",
    },
  ];

  /**
   * 智慧豆列表查询
   */
  const onSearchBtnClicked = useCallback(async () => {
    pageNo.current = 1;
    setBeansListCurPage(1);
    searchBeansList();
  }, [searchBeansList]);

  const [beansDetailListTotalNum, setBeansDetailListTotalNum] = useState(0);
  const [beansDetailListCurPage, setBeansDetailListCurPage] = useState(1);
  const rowRecordData = useRef({});

  const searchBeansDetailList = useCallback(async () => {
    const params = {
      page_no: detailPageNo.current,
      page_size: 10,
      user_no: rowRecordData.current.user_no || "",
    };

    const res = await getSmartBeanDetailList(params);
    if (res && res.code == 0 && res.data.list.length > 0) {
      setSmartBeanDetailList(res.data.list);
      setBeansDetailListTotalNum(res.data.count);
    }
  }, []);

  const onChangeBeansDetailListpage = useCallback(
    (current) => {
      setBeansDetailListCurPage(current);
      detailPageNo.current = current;
      searchBeansDetailList();
      // eslint-disable-next-line no-use-before-define
    },
    [searchBeansDetailList]
  );

  // 智慧豆详情分页属性
  const paginationPropsBeansDetail = {
    // showSizeChanger: true,
    // showQuickJumper: true,
    showTotal: () => `共${beansDetailListTotalNum}条`,
    // pageSize: 10,
    current: beansDetailListCurPage,
    total: beansDetailListTotalNum,
    // onShowSizeChange: (current, pageSize) =>
    //   this.changePageSize(pageSize, current),
    onChange: (current) => onChangeBeansDetailListpage(current),
  };

  const onSmartBeansClicked = useCallback(async (rowData) => {
    console.log("rowData:", rowData);
    rowRecordData.current = rowData || {};
    await searchBeansDetailList();
    setShowModal(true);
  }, []);

  const onUserNumChanged = useCallback((e) => {
    setUserNum(e.target.value);
  }, []);

  const onCountrysideItemSelected = useCallback(async (id, option) => {
    setDefaultCountrysideKey(id);
    setPeriedKey("");
    if (id > "") {
      // const res = await getRoleList({ depart_id: id });
      // if (res.code == 0 && res.data?.length > 0) {
      //   const roleData = res.data;
      // }
    }
  }, []);

  const onPeriedChanged = useCallback((id) => {
    setPeriedKey(id);
  }, []);

  const onEditModalCancel = useCallback(() => {
    setShowEditModal(false);
    setEditRecord(null);
    editForm.resetFields();
  }, [editForm]);

  const onUpdateStudentInfo = useCallback(async () => {
    if (!editRecord?.user_no) {
      message.error("缺少学号，无法修改");
      return;
    }

    let values;
    try {
      values = await editForm.validateFields();
    } catch (error) {
      return;
    }
    const params = {
      user_no: editRecord.user_no,
      nick_name: values.nick_name,
      gender: values.gender,
      phone_no: values.phone_no,
    };

    setUpdateLoading(true);
    try {
      const res = await updateStudentInfo(params);
      if (res.code == 0) {
        message.success("修改成功！");
        onEditModalCancel();
        searchBeansList();
      } else {
        message.error(`修改失败：${res.info || res.message || "未知错误"}`);
      }
    } finally {
      setUpdateLoading(false);
    }
  }, [editForm, editRecord, onEditModalCancel, searchBeansList]);

  return (
    <div className="container">
      <div className="searchContainer">
        <div className="searchInputContainer">
          <div className="searchItem">
            内容搜索：
            <Select
              defaultValue={searchType}
              style={{ width: 120 }}
              onChange={onSearchTypeChanged}
              options={[
                { value: 1, label: "学号" },
                { value: 2, label: "手机号" },
                { value: 3, label: "昵称" },
              ]}
            />
            <Input
              onChange={onUserNumChanged}
              style={{ height: 32, width: 160, marginLeft: 20 }}
            />
          </div>
          <div className="searchItem">
            所属村落：
            <Select
              value={defaultCountrysideKey}
              style={{ width: 160 }}
              onChange={onCountrysideItemSelected}
              fieldNames={{ label: "name", value: "id" }}
              options={countrysideData}
            />
            <span> - </span>
            <Select
              value={periedKey}
              style={{ width: 160 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onPeriedChanged}
              options={periedData}
            />
          </div>
        </div>

        <div className="btnContainer">
          <Button
            style={{ marginTop: 20 }}
            className="searchItem"
            type="primary"
            onClick={() => {
              onSearchBtnClicked();
              // test();
              // freezeMember("BJ2407028", 1);
            }}
          >
            查询
          </Button>
        </div>
      </div>

      <div className="contentContainer">
        <Table
          pagination={paginationProps}
          onRow={(record) => {
            console.log(record);
            return {
              onClick: (event) => {
                console.log("smart beans", event);
              },
            };
          }}
          dataSource={smartBeanList}
          columns={columns}
        />
      </div>

      <Modal
        title="智慧豆详细列表"
        open={false}
        width={1000}
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}
      >
        <Table
          pagination={paginationPropsBeansDetail}
          onRow={(record) => {
            console.log(record);
            return {
              onClick: (event) => {
                console.log(event);
              },
            };
          }}
          dataSource={smartBeanDetailList}
          columns={smartBeansDetail}
        />
      </Modal>
      <Modal
        title="修改学员信息"
        open={showEditModal}
        confirmLoading={updateLoading}
        onCancel={onEditModalCancel}
        onOk={onUpdateStudentInfo}
        okText="保存"
        cancelText="取消"
      >
        <Form
          form={editForm}
          layout="vertical"
          initialValues={{ gender: 0 }}
          preserve={false}
        >
          <Form.Item label="学号">
            <span>{editRecord?.user_no}</span>
          </Form.Item>
          <Form.Item
            name="nick_name"
            label="昵称"
            rules={[{ required: true, message: "请输入昵称" }]}
          >
            <Input placeholder="请输入昵称" />
          </Form.Item>
          <Form.Item
            name="gender"
            label="性别"
            rules={[{ required: true, message: "请选择性别" }]}
          >
            <Select
              options={[
                { value: 1, label: "男" },
                { value: 0, label: "女" },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="phone_no"
            label="手机号"
            rules={[
              { required: true, message: "请输入手机号" },
              { pattern: /^\d{11}$/, message: "请输入11位数字的手机号" },
            ]}
          >
            <Input placeholder="请输入手机号" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
